export enum BetOptions {
    Team = 'Team',
    Player = 'Player'
}